import { flatten } from 'lodash-es'

/**
 * Associate contacts to a location/company
 * This is necessary because the API only returns which address the user belongs to... but not what location that
 * address belongs to.
 *
 * @returns {*[]}
 */
export default function(locations) {
  // make sure we are always dealing with an array of locations
  const locationList = Array.isArray(locations) ? locations : [locations]

  // extract all the addresses from each location
  const addressPerLocation = locationList.map((loc) => {
    const locationName = loc.companyRolodexJobLocationName
    const addresses = loc.companyRolodexJobLocationAddresses
    return addresses.map((address) => ({ location: locationName, address }))
  })

  //  extract every contact from each address
  let contacts = flatten(addressPerLocation).map((mix) => {
    const contacts = mix.address.companyRolodexContacts

    return contacts.map((contact) => ({
      contact,
      location: mix.location,
      address: mix.address
    }))
  })

  return flatten(contacts)
}
